module.exports = __webpack_public_path__ + "img/shellcar.0d0a4514.jpg";